/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Help_Faq_Cannotchangeroles_Title3Inputs */

const en_usermanagement_help_faq_cannotchangeroles_title3 = /** @type {(inputs: Usermanagement_Help_Faq_Cannotchangeroles_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why can't I change the user roles for certain funds?`)
};

/**
* | output |
* | --- |
* | "Why can't I change the user roles for certain funds?" |
*
* @param {Usermanagement_Help_Faq_Cannotchangeroles_Title3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_help_faq_cannotchangeroles_title3 = /** @type {((inputs?: Usermanagement_Help_Faq_Cannotchangeroles_Title3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Help_Faq_Cannotchangeroles_Title3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_help_faq_cannotchangeroles_title3(inputs)
});
export { usermanagement_help_faq_cannotchangeroles_title3 as "userManagement_help_faq_cannotChangeRoles_title" }